import { validateNodeWithCharacters } from '~lib/common/validators/caseLogicDescription/characters/validateNodeWithCharacters';
import { validateRequiredFields } from '~lib/common/validators/caseLogicDescription/requiredFields/validateRequiredFields';

export default function validateNpcBehaviorNodes(caseConf, nodeInfo) {
  const errors = [];
  console.log('nodeInfo', nodeInfo)
  // Effect nodes
  nodeInfo.effectNodes.forEach((node) => {
    console.log('node', node)
    const nodeType = 'effect';
    const controlTypes = ['NPC_ANIMATION_REPEAT', 'NPC_ANIMATION_ONE_SHOT'];
    const characterErrors = validateNodeWithCharacters(node, nodeType, controlTypes, caseConf) || [];
    if (characterErrors.length > 0) errors.push(...characterErrors);
    const requiredFields = [
      {
        key: 'value',
        label: 'Behavior',
        errorId: 'missingValue',
      },
      {
        key: 'npcKey',
        label: 'Source Character',
        errorId: 'missingSourceCharacter'
      },
    ]
    const missingFieldErrors = validateRequiredFields(requiredFields, node, nodeType, controlTypes) || [];
    if (missingFieldErrors.length > 0) errors.push(...missingFieldErrors);
  });

  return {
    errors,
    warnings: [],
  };
}
